import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API } from "@/services/api";

export function useSchedulingData({ publicMode = false } = {}) {
  const empty = { providers: [], rooms: [], services: [], blocks: [], package_templates: [], google_calendar_sync: "" };
  const path = "scheduling/config";
  const query = useQuery({ queryKey: ["doctor-mo-scheduling-config", publicMode], queryFn: async () => (await axios.get(`${API}/${path}`)).data });
  return { scheduling: query.data || empty, refreshScheduling: query.refetch };
}
